import script from "./NftConstructorBgGalleryItem.vue?vue&type=script&setup=true&lang=js"
export * from "./NftConstructorBgGalleryItem.vue?vue&type=script&setup=true&lang=js"

import "./NftConstructorBgGalleryItem.vue?vue&type=style&index=0&id=40b95db0&lang=scss"

const __exports__ = script;

export default __exports__